import { ClientPlacedAd } from '@spp/ad-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const onErrorDefault = ({ adObj }) => {
    if (process.env.NODE_ENV === 'production') {
        return;
    }

    /* eslint-disable no-console */
    console.error('Failed to load an Ad: ', adObj);
};

/* eslint-disable */
export default class VgClientPlacedAd extends Component {
    static propTypes = {
        clientPlacedAds: PropTypes.arrayOf(PropTypes.object).isRequired,
        subtype: PropTypes.string.isRequired,
        onError: PropTypes.function,
        visibleOnError: PropTypes.bool,
    };

    render() {
        const {
            onError = onErrorDefault,
            subtype,
            clientPlacedAds,
            visibleOnError = true,
        } = this.props;

        return (
            <ClientPlacedAd
                subtype={subtype}
                clientPlacedAds={clientPlacedAds}
                priority="high"
                visibleOnError={visibleOnError}
                onError={onError}
            />
        );
    }
}
/* eslint-disable */



/** WEBPACK FOOTER **
 ** ./src/local-components/Ads/VgClientPlacedAd.js
 **/